    <form  class="flex flex-col gap-5 ">
        <div>
            <app-input
                    (onChangeInput)="select($event)"
                    [customClasses]="'!h-10'"
                    [labelClass]="'!text-start'"
                    [label]="'youtube_video_link'| translate"
                    [placeholder]="'video_link' | translate"
                    [type]="'text'"
            ></app-input>
        </div>

        <div class=" flex flex-col gap-2">
            <a
                    (click)="donate()"
                    class=" flex w-full items-center justify-center rounded-md border border-transparent bg-primary px-8 py-3 text-base font-medium text-normal hover:bg-primary-hover focus:outline-none focus:ring-2 focus:ring-primary cursor-pointer"
            >
                {{ 'donate'| translate }}
            </a>
        </div>
    </form>
